export default __webpack_public_path__ + "static/typingGIF-8f5062edae8c0e797c64e1afcacb9914.gif";